// @flow
import $ from 'jquery';
import JQueryView from '../../../common/JQueryView';
import { on } from '../../../../../admin/views/common/JQueryView';
import type { JQuery } from 'jquery';

export default class IndexView extends JQueryView {
  selectedItem: JQuery;

  constructor() {
    super('.modal-dialog');
  }

  @on({ event: 'click', selector: '.item-row' })
  onClickItemRow(event: any) {
    if (this.selectedItem) {
      this.selectedItem.removeClass('selected');
    }
    this.selectedItem = $(event.target).parent();
    this.selectedItem.addClass('selected');
    $('#right-type-basic-select-button').removeClass('disabled');
  }

  @on({ event: 'click', selector: '#right-type-basic-select-button' })
  onClickRightTypeBasicSelectButton(event: any) {
    event.preventDefault();
    if (this.selectedItem) {
      const itemId = this.selectedItem.attr('data-id');
      location.href = `/company/stock_options/${itemId}/issuances/edit/basic_information`;
    } else {
      alert('新株予約権データを選択してください。');
    }
  }
}
